module.exports = __webpack_public_path__ + "img/15.67b4fe79.png";